import HttpClient from './utils/HttpClient';
import APIError from '../errors/APIError';

import { IColor } from '../models';

class ColorsService {
  private httpClient = HttpClient;

  public async listColors(companyId: number): Promise<IColor[]> {
    try {
      const response = await this.httpClient.get(
        `/companies/${companyId}/colors`,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar as cores';
      }

      throw new APIError(errorMessage);
    }
  }

  public async createColor(companyId: number, data: any): Promise<IColor> {
    try {
      const response = await this.httpClient.post(
        `/companies/${companyId}/colors`,
        data,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar cadastrar a cor';
      }

      throw new APIError(errorMessage);
    }
  }

  public async generateColors(companyId: number): Promise<IColor[]> {
    try {
      const response = await this.httpClient.post(
        `/companies/${companyId}/colors/generate`,
        {},
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar gerar as cores';
      }

      throw new APIError(errorMessage);
    }
  }

  public async updateColors(companyId: number, colors: any): Promise<IColor[]> {
    try {
      const response = await this.httpClient.patch(
        `/companies/${companyId}/colors`,
        { colors },
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar editar as cores';
      }

      throw new APIError(errorMessage);
    }
  }

  public async deleteColor(companyId: number, colorId: number): Promise<void> {
    try {
      await this.httpClient.delete(`/companies/${companyId}/colors/${colorId}`);
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar excluir a cor';
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new ColorsService();
